/**
 * @generated SignedSource<<4b061c8b35cc08f8a7af62939352a03e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMorePageQuery$variables = {};
export type useMorePageQuery$data = {
  readonly userData: {
    readonly firstName: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useMoreSurveysBannerQuery_profileUrlRef">;
};
export type useMorePageQuery = {
  response: useMorePageQuery$data;
  variables: useMorePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useMorePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useMoreSurveysBannerQuery_profileUrlRef"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useMorePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endlessProfilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demographicProfileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileCompletion",
        "kind": "LinkedField",
        "name": "profileCompletionPercentage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileCompletionPercentage",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7222ca938e952c45ea02f1bbecce9549",
    "id": null,
    "metadata": {},
    "name": "useMorePageQuery",
    "operationKind": "query",
    "text": "query useMorePageQuery {\n  userData {\n    firstName\n    id\n  }\n  ...useMoreSurveysBannerQuery_profileUrlRef\n}\n\nfragment useMoreSurveysBannerQuery_profileUrlRef on Query {\n  endlessProfilerUrl\n  demographicProfileUrl\n  profilerUrl\n  profileCompletionPercentage {\n    profileCompletionPercentage\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d73abae5875197584f5c3ea45020346";

export default node;
